import { useLayoutEffect, useState } from 'react';

export const useAuthRedirect = () => {
    const [isRedirecting, setIsRedirecting] = useState(false);

    useLayoutEffect(() => {
        const originalOpen = XMLHttpRequest.prototype.open;

        XMLHttpRequest.prototype.open = function (...args: unknown[]) {
            this.addEventListener('readystatechange', () => {
                if (this.readyState === XMLHttpRequest.DONE && this.status === 401) {
                    let response;

                    try {
                        response = JSON.parse(this.responseText);
                    } catch {
                        // skip
                    }

                    const authUrl = response?.authUrl;

                    if (authUrl) {
                        setIsRedirecting(true);
                        window.open(authUrl, '_self');
                    }
                }
            });

            originalOpen.apply(this, args);
        };

        return () => {
            XMLHttpRequest.prototype.open = originalOpen;
        };
    }, []);

    return { isRedirecting };
};
